/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedTimesheetsRouteImport } from './routes/_authenticated/timesheets'
import { Route as AuthenticatedTasksRouteImport } from './routes/_authenticated/tasks'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedServiceCasesRouteImport } from './routes/_authenticated/service-cases'
import { Route as AuthenticatedRiskAssessmentsRouteImport } from './routes/_authenticated/risk-assessments'
import { Route as AuthenticatedReviewTasksRouteImport } from './routes/_authenticated/review-tasks'
import { Route as AuthenticatedReleasesRouteImport } from './routes/_authenticated/releases'
import { Route as AuthenticatedPhoneRouteImport } from './routes/_authenticated/phone'
import { Route as AuthenticatedPartsRouteImport } from './routes/_authenticated/parts'
import { Route as AuthenticatedOpsInboxRouteImport } from './routes/_authenticated/ops-inbox'
import { Route as AuthenticatedOfficeActionsRouteImport } from './routes/_authenticated/office-actions'
import { Route as AuthenticatedLeadsRouteImport } from './routes/_authenticated/leads'
import { Route as AuthenticatedInventoryRouteImport } from './routes/_authenticated/inventory'
import { Route as AuthenticatedDocsRouteImport } from './routes/_authenticated/docs'
import { Route as AuthenticatedDispatchBoardRouteImport } from './routes/_authenticated/dispatch-board'
import { Route as AuthenticatedDataManagementRouteImport } from './routes/_authenticated/data-management'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedBookingRouteImport } from './routes/_authenticated/booking'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedPhoneIndexRouteImport } from './routes/_authenticated/phone/index'
import { Route as AuthenticatedOpsInboxIndexRouteImport } from './routes/_authenticated/ops-inbox/index'
import { Route as AuthenticatedJobsIndexRouteImport } from './routes/_authenticated/jobs/index'
import { Route as AuthenticatedInvoicesIndexRouteImport } from './routes/_authenticated/invoices/index'
import { Route as AuthenticatedCustomersIndexRouteImport } from './routes/_authenticated/customers/index'
import { Route as AuthenticatedCompaniesIndexRouteImport } from './routes/_authenticated/companies/index'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedSettingsSecurityRouteImport } from './routes/_authenticated/settings/security'
import { Route as AuthenticatedSettingsProfileRouteImport } from './routes/_authenticated/settings/profile'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsAppearanceRouteImport } from './routes/_authenticated/settings/appearance'
import { Route as AuthenticatedServiceCasesIdRouteImport } from './routes/_authenticated/service-cases/$id'
import { Route as AuthenticatedSchedulingSlotTemplatesRouteImport } from './routes/_authenticated/scheduling/slot-templates'
import { Route as AuthenticatedSchedulingSlotReservationsRouteImport } from './routes/_authenticated/scheduling/slot-reservations'
import { Route as AuthenticatedSchedulingCustomSlotRequestsRouteImport } from './routes/_authenticated/scheduling/custom-slot-requests'
import { Route as AuthenticatedSchedulingCapacityPlansRouteImport } from './routes/_authenticated/scheduling/capacity-plans'
import { Route as AuthenticatedPhoneVoicemailRouteImport } from './routes/_authenticated/phone/voicemail'
import { Route as AuthenticatedPhoneSmsRouteImport } from './routes/_authenticated/phone/sms'
import { Route as AuthenticatedPhoneRoutingRouteImport } from './routes/_authenticated/phone/routing'
import { Route as AuthenticatedPhoneConfigRouteImport } from './routes/_authenticated/phone/config'
import { Route as AuthenticatedPhoneCallsRouteImport } from './routes/_authenticated/phone/calls'
import { Route as AuthenticatedPhoneAnalyticsRouteImport } from './routes/_authenticated/phone/analytics'
import { Route as AuthenticatedPhoneAgentsRouteImport } from './routes/_authenticated/phone/agents'
import { Route as AuthenticatedOpsInboxFailedOperationsRouteImport } from './routes/_authenticated/ops-inbox/failed-operations'
import { Route as AuthenticatedOpsInboxExceptionsRouteImport } from './routes/_authenticated/ops-inbox/exceptions'
import { Route as AuthenticatedOpsInboxCustomSlotApprovalsRouteImport } from './routes/_authenticated/ops-inbox/custom-slot-approvals'
import { Route as AuthenticatedOpsInboxApprovalsRouteImport } from './routes/_authenticated/ops-inbox/approvals'
import { Route as AuthenticatedOpsInboxAllRouteImport } from './routes/_authenticated/ops-inbox/all'
import { Route as AuthenticatedOpsInboxAiActionReviewsRouteImport } from './routes/_authenticated/ops-inbox/ai-action-reviews'
import { Route as AuthenticatedJobsJobIdRouteImport } from './routes/_authenticated/jobs/$jobId'
import { Route as AuthenticatedInvoicesNewRouteImport } from './routes/_authenticated/invoices/new'
import { Route as AuthenticatedInvoicesInvoiceIdRouteImport } from './routes/_authenticated/invoices/$invoiceId'
import { Route as AuthenticatedCustomersNewRouteImport } from './routes/_authenticated/customers/new'
import { Route as AuthenticatedCustomersCustomerIdRouteImport } from './routes/_authenticated/customers/$customerId'
import { Route as AuthenticatedCompaniesCompanyIdRouteImport } from './routes/_authenticated/companies/$companyId'
import { Route as AuthenticatedAdminTeamRouteImport } from './routes/_authenticated/admin/team'
import { Route as AuthenticatedAdminSystemRouteImport } from './routes/_authenticated/admin/system'
import { Route as AuthenticatedAdminAiEngineRouteImport } from './routes/_authenticated/admin/ai-engine'
import { Route as AuthenticatedAdminAccessRouteImport } from './routes/_authenticated/admin/access'
import { Route as AuthenticatedServiceCasesIdIndexRouteImport } from './routes/_authenticated/service-cases/$id/index'
import { Route as AuthenticatedJobsJobIdIndexRouteImport } from './routes/_authenticated/jobs/$jobId/index'
import { Route as AuthenticatedAdminSystemIndexRouteImport } from './routes/_authenticated/admin/system/index'
import { Route as AuthenticatedServiceCasesIdPartsRouteImport } from './routes/_authenticated/service-cases/$id/parts'
import { Route as AuthenticatedServiceCasesIdOverviewRouteImport } from './routes/_authenticated/service-cases/$id/overview'
import { Route as AuthenticatedServiceCasesIdEstimatesRouteImport } from './routes/_authenticated/service-cases/$id/estimates'
import { Route as AuthenticatedServiceCasesIdAuditRouteImport } from './routes/_authenticated/service-cases/$id/audit'
import { Route as AuthenticatedServiceCasesIdAppointmentsRouteImport } from './routes/_authenticated/service-cases/$id/appointments'
import { Route as AuthenticatedJobsJobIdOverviewRouteImport } from './routes/_authenticated/jobs/$jobId/overview'
import { Route as AuthenticatedJobsJobIdNotesRouteImport } from './routes/_authenticated/jobs/$jobId/notes'
import { Route as AuthenticatedAdminSystemRbacRouteImport } from './routes/_authenticated/admin/system/rbac'
import { Route as AuthenticatedAdminSystemMigrationsRouteImport } from './routes/_authenticated/admin/system/migrations'
import { Route as AuthenticatedAdminSystemLogsRouteImport } from './routes/_authenticated/admin/system/logs'
import { Route as AuthenticatedAdminSystemDataMigrationRouteImport } from './routes/_authenticated/admin/system/data-migration'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedTimesheetsRoute = AuthenticatedTimesheetsRouteImport.update({
  id: '/timesheets',
  path: '/timesheets',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTasksRoute = AuthenticatedTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedServiceCasesRoute =
  AuthenticatedServiceCasesRouteImport.update({
    id: '/service-cases',
    path: '/service-cases',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRiskAssessmentsRoute =
  AuthenticatedRiskAssessmentsRouteImport.update({
    id: '/risk-assessments',
    path: '/risk-assessments',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReviewTasksRoute =
  AuthenticatedReviewTasksRouteImport.update({
    id: '/review-tasks',
    path: '/review-tasks',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReleasesRoute = AuthenticatedReleasesRouteImport.update({
  id: '/releases',
  path: '/releases',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPhoneRoute = AuthenticatedPhoneRouteImport.update({
  id: '/phone',
  path: '/phone',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPartsRoute = AuthenticatedPartsRouteImport.update({
  id: '/parts',
  path: '/parts',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOpsInboxRoute = AuthenticatedOpsInboxRouteImport.update({
  id: '/ops-inbox',
  path: '/ops-inbox',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOfficeActionsRoute =
  AuthenticatedOfficeActionsRouteImport.update({
    id: '/office-actions',
    path: '/office-actions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLeadsRoute = AuthenticatedLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInventoryRoute = AuthenticatedInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDocsRoute = AuthenticatedDocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDispatchBoardRoute =
  AuthenticatedDispatchBoardRouteImport.update({
    id: '/dispatch-board',
    path: '/dispatch-board',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDataManagementRoute =
  AuthenticatedDataManagementRouteImport.update({
    id: '/data-management',
    path: '/data-management',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBookingRoute = AuthenticatedBookingRouteImport.update({
  id: '/booking',
  path: '/booking',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedPhoneIndexRoute = AuthenticatedPhoneIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedPhoneRoute,
} as any)
const AuthenticatedOpsInboxIndexRoute =
  AuthenticatedOpsInboxIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOpsInboxRoute,
  } as any)
const AuthenticatedJobsIndexRoute = AuthenticatedJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInvoicesIndexRoute =
  AuthenticatedInvoicesIndexRouteImport.update({
    id: '/invoices/',
    path: '/invoices/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomersIndexRoute =
  AuthenticatedCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompaniesIndexRoute =
  AuthenticatedCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedSettingsSecurityRoute =
  AuthenticatedSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsProfileRoute =
  AuthenticatedSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAppearanceRoute =
  AuthenticatedSettingsAppearanceRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedServiceCasesIdRoute =
  AuthenticatedServiceCasesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedServiceCasesRoute,
  } as any)
const AuthenticatedSchedulingSlotTemplatesRoute =
  AuthenticatedSchedulingSlotTemplatesRouteImport.update({
    id: '/scheduling/slot-templates',
    path: '/scheduling/slot-templates',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSchedulingSlotReservationsRoute =
  AuthenticatedSchedulingSlotReservationsRouteImport.update({
    id: '/scheduling/slot-reservations',
    path: '/scheduling/slot-reservations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSchedulingCustomSlotRequestsRoute =
  AuthenticatedSchedulingCustomSlotRequestsRouteImport.update({
    id: '/scheduling/custom-slot-requests',
    path: '/scheduling/custom-slot-requests',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSchedulingCapacityPlansRoute =
  AuthenticatedSchedulingCapacityPlansRouteImport.update({
    id: '/scheduling/capacity-plans',
    path: '/scheduling/capacity-plans',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPhoneVoicemailRoute =
  AuthenticatedPhoneVoicemailRouteImport.update({
    id: '/voicemail',
    path: '/voicemail',
    getParentRoute: () => AuthenticatedPhoneRoute,
  } as any)
const AuthenticatedPhoneSmsRoute = AuthenticatedPhoneSmsRouteImport.update({
  id: '/sms',
  path: '/sms',
  getParentRoute: () => AuthenticatedPhoneRoute,
} as any)
const AuthenticatedPhoneRoutingRoute =
  AuthenticatedPhoneRoutingRouteImport.update({
    id: '/routing',
    path: '/routing',
    getParentRoute: () => AuthenticatedPhoneRoute,
  } as any)
const AuthenticatedPhoneConfigRoute =
  AuthenticatedPhoneConfigRouteImport.update({
    id: '/config',
    path: '/config',
    getParentRoute: () => AuthenticatedPhoneRoute,
  } as any)
const AuthenticatedPhoneCallsRoute = AuthenticatedPhoneCallsRouteImport.update({
  id: '/calls',
  path: '/calls',
  getParentRoute: () => AuthenticatedPhoneRoute,
} as any)
const AuthenticatedPhoneAnalyticsRoute =
  AuthenticatedPhoneAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthenticatedPhoneRoute,
  } as any)
const AuthenticatedPhoneAgentsRoute =
  AuthenticatedPhoneAgentsRouteImport.update({
    id: '/agents',
    path: '/agents',
    getParentRoute: () => AuthenticatedPhoneRoute,
  } as any)
const AuthenticatedOpsInboxFailedOperationsRoute =
  AuthenticatedOpsInboxFailedOperationsRouteImport.update({
    id: '/failed-operations',
    path: '/failed-operations',
    getParentRoute: () => AuthenticatedOpsInboxRoute,
  } as any)
const AuthenticatedOpsInboxExceptionsRoute =
  AuthenticatedOpsInboxExceptionsRouteImport.update({
    id: '/exceptions',
    path: '/exceptions',
    getParentRoute: () => AuthenticatedOpsInboxRoute,
  } as any)
const AuthenticatedOpsInboxCustomSlotApprovalsRoute =
  AuthenticatedOpsInboxCustomSlotApprovalsRouteImport.update({
    id: '/custom-slot-approvals',
    path: '/custom-slot-approvals',
    getParentRoute: () => AuthenticatedOpsInboxRoute,
  } as any)
const AuthenticatedOpsInboxApprovalsRoute =
  AuthenticatedOpsInboxApprovalsRouteImport.update({
    id: '/approvals',
    path: '/approvals',
    getParentRoute: () => AuthenticatedOpsInboxRoute,
  } as any)
const AuthenticatedOpsInboxAllRoute =
  AuthenticatedOpsInboxAllRouteImport.update({
    id: '/all',
    path: '/all',
    getParentRoute: () => AuthenticatedOpsInboxRoute,
  } as any)
const AuthenticatedOpsInboxAiActionReviewsRoute =
  AuthenticatedOpsInboxAiActionReviewsRouteImport.update({
    id: '/ai-action-reviews',
    path: '/ai-action-reviews',
    getParentRoute: () => AuthenticatedOpsInboxRoute,
  } as any)
const AuthenticatedJobsJobIdRoute = AuthenticatedJobsJobIdRouteImport.update({
  id: '/jobs/$jobId',
  path: '/jobs/$jobId',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInvoicesNewRoute =
  AuthenticatedInvoicesNewRouteImport.update({
    id: '/invoices/new',
    path: '/invoices/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInvoicesInvoiceIdRoute =
  AuthenticatedInvoicesInvoiceIdRouteImport.update({
    id: '/invoices/$invoiceId',
    path: '/invoices/$invoiceId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomersNewRoute =
  AuthenticatedCustomersNewRouteImport.update({
    id: '/customers/new',
    path: '/customers/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomersCustomerIdRoute =
  AuthenticatedCustomersCustomerIdRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdRoute =
  AuthenticatedCompaniesCompanyIdRouteImport.update({
    id: '/companies/$companyId',
    path: '/companies/$companyId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminTeamRoute = AuthenticatedAdminTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminSystemRoute =
  AuthenticatedAdminSystemRouteImport.update({
    id: '/system',
    path: '/system',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAiEngineRoute =
  AuthenticatedAdminAiEngineRouteImport.update({
    id: '/ai-engine',
    path: '/ai-engine',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAccessRoute =
  AuthenticatedAdminAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedServiceCasesIdIndexRoute =
  AuthenticatedServiceCasesIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedServiceCasesIdRoute,
  } as any)
const AuthenticatedJobsJobIdIndexRoute =
  AuthenticatedJobsJobIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedJobsJobIdRoute,
  } as any)
const AuthenticatedAdminSystemIndexRoute =
  AuthenticatedAdminSystemIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAdminSystemRoute,
  } as any)
const AuthenticatedServiceCasesIdPartsRoute =
  AuthenticatedServiceCasesIdPartsRouteImport.update({
    id: '/parts',
    path: '/parts',
    getParentRoute: () => AuthenticatedServiceCasesIdRoute,
  } as any)
const AuthenticatedServiceCasesIdOverviewRoute =
  AuthenticatedServiceCasesIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthenticatedServiceCasesIdRoute,
  } as any)
const AuthenticatedServiceCasesIdEstimatesRoute =
  AuthenticatedServiceCasesIdEstimatesRouteImport.update({
    id: '/estimates',
    path: '/estimates',
    getParentRoute: () => AuthenticatedServiceCasesIdRoute,
  } as any)
const AuthenticatedServiceCasesIdAuditRoute =
  AuthenticatedServiceCasesIdAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AuthenticatedServiceCasesIdRoute,
  } as any)
const AuthenticatedServiceCasesIdAppointmentsRoute =
  AuthenticatedServiceCasesIdAppointmentsRouteImport.update({
    id: '/appointments',
    path: '/appointments',
    getParentRoute: () => AuthenticatedServiceCasesIdRoute,
  } as any)
const AuthenticatedJobsJobIdOverviewRoute =
  AuthenticatedJobsJobIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthenticatedJobsJobIdRoute,
  } as any)
const AuthenticatedJobsJobIdNotesRoute =
  AuthenticatedJobsJobIdNotesRouteImport.update({
    id: '/notes',
    path: '/notes',
    getParentRoute: () => AuthenticatedJobsJobIdRoute,
  } as any)
const AuthenticatedAdminSystemRbacRoute =
  AuthenticatedAdminSystemRbacRouteImport.update({
    id: '/rbac',
    path: '/rbac',
    getParentRoute: () => AuthenticatedAdminSystemRoute,
  } as any)
const AuthenticatedAdminSystemMigrationsRoute =
  AuthenticatedAdminSystemMigrationsRouteImport.update({
    id: '/migrations',
    path: '/migrations',
    getParentRoute: () => AuthenticatedAdminSystemRoute,
  } as any)
const AuthenticatedAdminSystemLogsRoute =
  AuthenticatedAdminSystemLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => AuthenticatedAdminSystemRoute,
  } as any)
const AuthenticatedAdminSystemDataMigrationRoute =
  AuthenticatedAdminSystemDataMigrationRouteImport.update({
    id: '/data-migration',
    path: '/data-migration',
    getParentRoute: () => AuthenticatedAdminSystemRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/booking': typeof AuthenticatedBookingRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/data-management': typeof AuthenticatedDataManagementRoute
  '/dispatch-board': typeof AuthenticatedDispatchBoardRoute
  '/docs': typeof AuthenticatedDocsRoute
  '/inventory': typeof AuthenticatedInventoryRoute
  '/leads': typeof AuthenticatedLeadsRoute
  '/office-actions': typeof AuthenticatedOfficeActionsRoute
  '/ops-inbox': typeof AuthenticatedOpsInboxRouteWithChildren
  '/parts': typeof AuthenticatedPartsRoute
  '/phone': typeof AuthenticatedPhoneRouteWithChildren
  '/releases': typeof AuthenticatedReleasesRoute
  '/review-tasks': typeof AuthenticatedReviewTasksRoute
  '/risk-assessments': typeof AuthenticatedRiskAssessmentsRoute
  '/service-cases': typeof AuthenticatedServiceCasesRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/tasks': typeof AuthenticatedTasksRoute
  '/timesheets': typeof AuthenticatedTimesheetsRoute
  '/admin/access': typeof AuthenticatedAdminAccessRoute
  '/admin/ai-engine': typeof AuthenticatedAdminAiEngineRoute
  '/admin/system': typeof AuthenticatedAdminSystemRouteWithChildren
  '/admin/team': typeof AuthenticatedAdminTeamRoute
  '/companies/$companyId': typeof AuthenticatedCompaniesCompanyIdRoute
  '/customers/$customerId': typeof AuthenticatedCustomersCustomerIdRoute
  '/customers/new': typeof AuthenticatedCustomersNewRoute
  '/invoices/$invoiceId': typeof AuthenticatedInvoicesInvoiceIdRoute
  '/invoices/new': typeof AuthenticatedInvoicesNewRoute
  '/jobs/$jobId': typeof AuthenticatedJobsJobIdRouteWithChildren
  '/ops-inbox/ai-action-reviews': typeof AuthenticatedOpsInboxAiActionReviewsRoute
  '/ops-inbox/all': typeof AuthenticatedOpsInboxAllRoute
  '/ops-inbox/approvals': typeof AuthenticatedOpsInboxApprovalsRoute
  '/ops-inbox/custom-slot-approvals': typeof AuthenticatedOpsInboxCustomSlotApprovalsRoute
  '/ops-inbox/exceptions': typeof AuthenticatedOpsInboxExceptionsRoute
  '/ops-inbox/failed-operations': typeof AuthenticatedOpsInboxFailedOperationsRoute
  '/phone/agents': typeof AuthenticatedPhoneAgentsRoute
  '/phone/analytics': typeof AuthenticatedPhoneAnalyticsRoute
  '/phone/calls': typeof AuthenticatedPhoneCallsRoute
  '/phone/config': typeof AuthenticatedPhoneConfigRoute
  '/phone/routing': typeof AuthenticatedPhoneRoutingRoute
  '/phone/sms': typeof AuthenticatedPhoneSmsRoute
  '/phone/voicemail': typeof AuthenticatedPhoneVoicemailRoute
  '/scheduling/capacity-plans': typeof AuthenticatedSchedulingCapacityPlansRoute
  '/scheduling/custom-slot-requests': typeof AuthenticatedSchedulingCustomSlotRequestsRoute
  '/scheduling/slot-reservations': typeof AuthenticatedSchedulingSlotReservationsRoute
  '/scheduling/slot-templates': typeof AuthenticatedSchedulingSlotTemplatesRoute
  '/service-cases/$id': typeof AuthenticatedServiceCasesIdRouteWithChildren
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/customers/': typeof AuthenticatedCustomersIndexRoute
  '/invoices/': typeof AuthenticatedInvoicesIndexRoute
  '/jobs/': typeof AuthenticatedJobsIndexRoute
  '/ops-inbox/': typeof AuthenticatedOpsInboxIndexRoute
  '/phone/': typeof AuthenticatedPhoneIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/admin/system/data-migration': typeof AuthenticatedAdminSystemDataMigrationRoute
  '/admin/system/logs': typeof AuthenticatedAdminSystemLogsRoute
  '/admin/system/migrations': typeof AuthenticatedAdminSystemMigrationsRoute
  '/admin/system/rbac': typeof AuthenticatedAdminSystemRbacRoute
  '/jobs/$jobId/notes': typeof AuthenticatedJobsJobIdNotesRoute
  '/jobs/$jobId/overview': typeof AuthenticatedJobsJobIdOverviewRoute
  '/service-cases/$id/appointments': typeof AuthenticatedServiceCasesIdAppointmentsRoute
  '/service-cases/$id/audit': typeof AuthenticatedServiceCasesIdAuditRoute
  '/service-cases/$id/estimates': typeof AuthenticatedServiceCasesIdEstimatesRoute
  '/service-cases/$id/overview': typeof AuthenticatedServiceCasesIdOverviewRoute
  '/service-cases/$id/parts': typeof AuthenticatedServiceCasesIdPartsRoute
  '/admin/system/': typeof AuthenticatedAdminSystemIndexRoute
  '/jobs/$jobId/': typeof AuthenticatedJobsJobIdIndexRoute
  '/service-cases/$id/': typeof AuthenticatedServiceCasesIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/booking': typeof AuthenticatedBookingRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/data-management': typeof AuthenticatedDataManagementRoute
  '/dispatch-board': typeof AuthenticatedDispatchBoardRoute
  '/docs': typeof AuthenticatedDocsRoute
  '/inventory': typeof AuthenticatedInventoryRoute
  '/leads': typeof AuthenticatedLeadsRoute
  '/office-actions': typeof AuthenticatedOfficeActionsRoute
  '/parts': typeof AuthenticatedPartsRoute
  '/releases': typeof AuthenticatedReleasesRoute
  '/review-tasks': typeof AuthenticatedReviewTasksRoute
  '/risk-assessments': typeof AuthenticatedRiskAssessmentsRoute
  '/service-cases': typeof AuthenticatedServiceCasesRouteWithChildren
  '/tasks': typeof AuthenticatedTasksRoute
  '/timesheets': typeof AuthenticatedTimesheetsRoute
  '/admin/access': typeof AuthenticatedAdminAccessRoute
  '/admin/ai-engine': typeof AuthenticatedAdminAiEngineRoute
  '/admin/team': typeof AuthenticatedAdminTeamRoute
  '/companies/$companyId': typeof AuthenticatedCompaniesCompanyIdRoute
  '/customers/$customerId': typeof AuthenticatedCustomersCustomerIdRoute
  '/customers/new': typeof AuthenticatedCustomersNewRoute
  '/invoices/$invoiceId': typeof AuthenticatedInvoicesInvoiceIdRoute
  '/invoices/new': typeof AuthenticatedInvoicesNewRoute
  '/ops-inbox/ai-action-reviews': typeof AuthenticatedOpsInboxAiActionReviewsRoute
  '/ops-inbox/all': typeof AuthenticatedOpsInboxAllRoute
  '/ops-inbox/approvals': typeof AuthenticatedOpsInboxApprovalsRoute
  '/ops-inbox/custom-slot-approvals': typeof AuthenticatedOpsInboxCustomSlotApprovalsRoute
  '/ops-inbox/exceptions': typeof AuthenticatedOpsInboxExceptionsRoute
  '/ops-inbox/failed-operations': typeof AuthenticatedOpsInboxFailedOperationsRoute
  '/phone/agents': typeof AuthenticatedPhoneAgentsRoute
  '/phone/analytics': typeof AuthenticatedPhoneAnalyticsRoute
  '/phone/calls': typeof AuthenticatedPhoneCallsRoute
  '/phone/config': typeof AuthenticatedPhoneConfigRoute
  '/phone/routing': typeof AuthenticatedPhoneRoutingRoute
  '/phone/sms': typeof AuthenticatedPhoneSmsRoute
  '/phone/voicemail': typeof AuthenticatedPhoneVoicemailRoute
  '/scheduling/capacity-plans': typeof AuthenticatedSchedulingCapacityPlansRoute
  '/scheduling/custom-slot-requests': typeof AuthenticatedSchedulingCustomSlotRequestsRoute
  '/scheduling/slot-reservations': typeof AuthenticatedSchedulingSlotReservationsRoute
  '/scheduling/slot-templates': typeof AuthenticatedSchedulingSlotTemplatesRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/companies': typeof AuthenticatedCompaniesIndexRoute
  '/customers': typeof AuthenticatedCustomersIndexRoute
  '/invoices': typeof AuthenticatedInvoicesIndexRoute
  '/jobs': typeof AuthenticatedJobsIndexRoute
  '/ops-inbox': typeof AuthenticatedOpsInboxIndexRoute
  '/phone': typeof AuthenticatedPhoneIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/admin/system/data-migration': typeof AuthenticatedAdminSystemDataMigrationRoute
  '/admin/system/logs': typeof AuthenticatedAdminSystemLogsRoute
  '/admin/system/migrations': typeof AuthenticatedAdminSystemMigrationsRoute
  '/admin/system/rbac': typeof AuthenticatedAdminSystemRbacRoute
  '/jobs/$jobId/notes': typeof AuthenticatedJobsJobIdNotesRoute
  '/jobs/$jobId/overview': typeof AuthenticatedJobsJobIdOverviewRoute
  '/service-cases/$id/appointments': typeof AuthenticatedServiceCasesIdAppointmentsRoute
  '/service-cases/$id/audit': typeof AuthenticatedServiceCasesIdAuditRoute
  '/service-cases/$id/estimates': typeof AuthenticatedServiceCasesIdEstimatesRoute
  '/service-cases/$id/overview': typeof AuthenticatedServiceCasesIdOverviewRoute
  '/service-cases/$id/parts': typeof AuthenticatedServiceCasesIdPartsRoute
  '/admin/system': typeof AuthenticatedAdminSystemIndexRoute
  '/jobs/$jobId': typeof AuthenticatedJobsJobIdIndexRoute
  '/service-cases/$id': typeof AuthenticatedServiceCasesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/_authenticated/booking': typeof AuthenticatedBookingRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/data-management': typeof AuthenticatedDataManagementRoute
  '/_authenticated/dispatch-board': typeof AuthenticatedDispatchBoardRoute
  '/_authenticated/docs': typeof AuthenticatedDocsRoute
  '/_authenticated/inventory': typeof AuthenticatedInventoryRoute
  '/_authenticated/leads': typeof AuthenticatedLeadsRoute
  '/_authenticated/office-actions': typeof AuthenticatedOfficeActionsRoute
  '/_authenticated/ops-inbox': typeof AuthenticatedOpsInboxRouteWithChildren
  '/_authenticated/parts': typeof AuthenticatedPartsRoute
  '/_authenticated/phone': typeof AuthenticatedPhoneRouteWithChildren
  '/_authenticated/releases': typeof AuthenticatedReleasesRoute
  '/_authenticated/review-tasks': typeof AuthenticatedReviewTasksRoute
  '/_authenticated/risk-assessments': typeof AuthenticatedRiskAssessmentsRoute
  '/_authenticated/service-cases': typeof AuthenticatedServiceCasesRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/_authenticated/tasks': typeof AuthenticatedTasksRoute
  '/_authenticated/timesheets': typeof AuthenticatedTimesheetsRoute
  '/_authenticated/admin/access': typeof AuthenticatedAdminAccessRoute
  '/_authenticated/admin/ai-engine': typeof AuthenticatedAdminAiEngineRoute
  '/_authenticated/admin/system': typeof AuthenticatedAdminSystemRouteWithChildren
  '/_authenticated/admin/team': typeof AuthenticatedAdminTeamRoute
  '/_authenticated/companies/$companyId': typeof AuthenticatedCompaniesCompanyIdRoute
  '/_authenticated/customers/$customerId': typeof AuthenticatedCustomersCustomerIdRoute
  '/_authenticated/customers/new': typeof AuthenticatedCustomersNewRoute
  '/_authenticated/invoices/$invoiceId': typeof AuthenticatedInvoicesInvoiceIdRoute
  '/_authenticated/invoices/new': typeof AuthenticatedInvoicesNewRoute
  '/_authenticated/jobs/$jobId': typeof AuthenticatedJobsJobIdRouteWithChildren
  '/_authenticated/ops-inbox/ai-action-reviews': typeof AuthenticatedOpsInboxAiActionReviewsRoute
  '/_authenticated/ops-inbox/all': typeof AuthenticatedOpsInboxAllRoute
  '/_authenticated/ops-inbox/approvals': typeof AuthenticatedOpsInboxApprovalsRoute
  '/_authenticated/ops-inbox/custom-slot-approvals': typeof AuthenticatedOpsInboxCustomSlotApprovalsRoute
  '/_authenticated/ops-inbox/exceptions': typeof AuthenticatedOpsInboxExceptionsRoute
  '/_authenticated/ops-inbox/failed-operations': typeof AuthenticatedOpsInboxFailedOperationsRoute
  '/_authenticated/phone/agents': typeof AuthenticatedPhoneAgentsRoute
  '/_authenticated/phone/analytics': typeof AuthenticatedPhoneAnalyticsRoute
  '/_authenticated/phone/calls': typeof AuthenticatedPhoneCallsRoute
  '/_authenticated/phone/config': typeof AuthenticatedPhoneConfigRoute
  '/_authenticated/phone/routing': typeof AuthenticatedPhoneRoutingRoute
  '/_authenticated/phone/sms': typeof AuthenticatedPhoneSmsRoute
  '/_authenticated/phone/voicemail': typeof AuthenticatedPhoneVoicemailRoute
  '/_authenticated/scheduling/capacity-plans': typeof AuthenticatedSchedulingCapacityPlansRoute
  '/_authenticated/scheduling/custom-slot-requests': typeof AuthenticatedSchedulingCustomSlotRequestsRoute
  '/_authenticated/scheduling/slot-reservations': typeof AuthenticatedSchedulingSlotReservationsRoute
  '/_authenticated/scheduling/slot-templates': typeof AuthenticatedSchedulingSlotTemplatesRoute
  '/_authenticated/service-cases/$id': typeof AuthenticatedServiceCasesIdRouteWithChildren
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/_authenticated/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/_authenticated/customers/': typeof AuthenticatedCustomersIndexRoute
  '/_authenticated/invoices/': typeof AuthenticatedInvoicesIndexRoute
  '/_authenticated/jobs/': typeof AuthenticatedJobsIndexRoute
  '/_authenticated/ops-inbox/': typeof AuthenticatedOpsInboxIndexRoute
  '/_authenticated/phone/': typeof AuthenticatedPhoneIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/admin/system/data-migration': typeof AuthenticatedAdminSystemDataMigrationRoute
  '/_authenticated/admin/system/logs': typeof AuthenticatedAdminSystemLogsRoute
  '/_authenticated/admin/system/migrations': typeof AuthenticatedAdminSystemMigrationsRoute
  '/_authenticated/admin/system/rbac': typeof AuthenticatedAdminSystemRbacRoute
  '/_authenticated/jobs/$jobId/notes': typeof AuthenticatedJobsJobIdNotesRoute
  '/_authenticated/jobs/$jobId/overview': typeof AuthenticatedJobsJobIdOverviewRoute
  '/_authenticated/service-cases/$id/appointments': typeof AuthenticatedServiceCasesIdAppointmentsRoute
  '/_authenticated/service-cases/$id/audit': typeof AuthenticatedServiceCasesIdAuditRoute
  '/_authenticated/service-cases/$id/estimates': typeof AuthenticatedServiceCasesIdEstimatesRoute
  '/_authenticated/service-cases/$id/overview': typeof AuthenticatedServiceCasesIdOverviewRoute
  '/_authenticated/service-cases/$id/parts': typeof AuthenticatedServiceCasesIdPartsRoute
  '/_authenticated/admin/system/': typeof AuthenticatedAdminSystemIndexRoute
  '/_authenticated/jobs/$jobId/': typeof AuthenticatedJobsJobIdIndexRoute
  '/_authenticated/service-cases/$id/': typeof AuthenticatedServiceCasesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin'
    | '/booking'
    | '/dashboard'
    | '/data-management'
    | '/dispatch-board'
    | '/docs'
    | '/inventory'
    | '/leads'
    | '/office-actions'
    | '/ops-inbox'
    | '/parts'
    | '/phone'
    | '/releases'
    | '/review-tasks'
    | '/risk-assessments'
    | '/service-cases'
    | '/settings'
    | '/tasks'
    | '/timesheets'
    | '/admin/access'
    | '/admin/ai-engine'
    | '/admin/system'
    | '/admin/team'
    | '/companies/$companyId'
    | '/customers/$customerId'
    | '/customers/new'
    | '/invoices/$invoiceId'
    | '/invoices/new'
    | '/jobs/$jobId'
    | '/ops-inbox/ai-action-reviews'
    | '/ops-inbox/all'
    | '/ops-inbox/approvals'
    | '/ops-inbox/custom-slot-approvals'
    | '/ops-inbox/exceptions'
    | '/ops-inbox/failed-operations'
    | '/phone/agents'
    | '/phone/analytics'
    | '/phone/calls'
    | '/phone/config'
    | '/phone/routing'
    | '/phone/sms'
    | '/phone/voicemail'
    | '/scheduling/capacity-plans'
    | '/scheduling/custom-slot-requests'
    | '/scheduling/slot-reservations'
    | '/scheduling/slot-templates'
    | '/service-cases/$id'
    | '/settings/appearance'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/security'
    | '/admin/'
    | '/companies/'
    | '/customers/'
    | '/invoices/'
    | '/jobs/'
    | '/ops-inbox/'
    | '/phone/'
    | '/settings/'
    | '/admin/system/data-migration'
    | '/admin/system/logs'
    | '/admin/system/migrations'
    | '/admin/system/rbac'
    | '/jobs/$jobId/notes'
    | '/jobs/$jobId/overview'
    | '/service-cases/$id/appointments'
    | '/service-cases/$id/audit'
    | '/service-cases/$id/estimates'
    | '/service-cases/$id/overview'
    | '/service-cases/$id/parts'
    | '/admin/system/'
    | '/jobs/$jobId/'
    | '/service-cases/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/booking'
    | '/dashboard'
    | '/data-management'
    | '/dispatch-board'
    | '/docs'
    | '/inventory'
    | '/leads'
    | '/office-actions'
    | '/parts'
    | '/releases'
    | '/review-tasks'
    | '/risk-assessments'
    | '/service-cases'
    | '/tasks'
    | '/timesheets'
    | '/admin/access'
    | '/admin/ai-engine'
    | '/admin/team'
    | '/companies/$companyId'
    | '/customers/$customerId'
    | '/customers/new'
    | '/invoices/$invoiceId'
    | '/invoices/new'
    | '/ops-inbox/ai-action-reviews'
    | '/ops-inbox/all'
    | '/ops-inbox/approvals'
    | '/ops-inbox/custom-slot-approvals'
    | '/ops-inbox/exceptions'
    | '/ops-inbox/failed-operations'
    | '/phone/agents'
    | '/phone/analytics'
    | '/phone/calls'
    | '/phone/config'
    | '/phone/routing'
    | '/phone/sms'
    | '/phone/voicemail'
    | '/scheduling/capacity-plans'
    | '/scheduling/custom-slot-requests'
    | '/scheduling/slot-reservations'
    | '/scheduling/slot-templates'
    | '/settings/appearance'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/security'
    | '/admin'
    | '/companies'
    | '/customers'
    | '/invoices'
    | '/jobs'
    | '/ops-inbox'
    | '/phone'
    | '/settings'
    | '/admin/system/data-migration'
    | '/admin/system/logs'
    | '/admin/system/migrations'
    | '/admin/system/rbac'
    | '/jobs/$jobId/notes'
    | '/jobs/$jobId/overview'
    | '/service-cases/$id/appointments'
    | '/service-cases/$id/audit'
    | '/service-cases/$id/estimates'
    | '/service-cases/$id/overview'
    | '/service-cases/$id/parts'
    | '/admin/system'
    | '/jobs/$jobId'
    | '/service-cases/$id'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/admin'
    | '/_authenticated/booking'
    | '/_authenticated/dashboard'
    | '/_authenticated/data-management'
    | '/_authenticated/dispatch-board'
    | '/_authenticated/docs'
    | '/_authenticated/inventory'
    | '/_authenticated/leads'
    | '/_authenticated/office-actions'
    | '/_authenticated/ops-inbox'
    | '/_authenticated/parts'
    | '/_authenticated/phone'
    | '/_authenticated/releases'
    | '/_authenticated/review-tasks'
    | '/_authenticated/risk-assessments'
    | '/_authenticated/service-cases'
    | '/_authenticated/settings'
    | '/_authenticated/tasks'
    | '/_authenticated/timesheets'
    | '/_authenticated/admin/access'
    | '/_authenticated/admin/ai-engine'
    | '/_authenticated/admin/system'
    | '/_authenticated/admin/team'
    | '/_authenticated/companies/$companyId'
    | '/_authenticated/customers/$customerId'
    | '/_authenticated/customers/new'
    | '/_authenticated/invoices/$invoiceId'
    | '/_authenticated/invoices/new'
    | '/_authenticated/jobs/$jobId'
    | '/_authenticated/ops-inbox/ai-action-reviews'
    | '/_authenticated/ops-inbox/all'
    | '/_authenticated/ops-inbox/approvals'
    | '/_authenticated/ops-inbox/custom-slot-approvals'
    | '/_authenticated/ops-inbox/exceptions'
    | '/_authenticated/ops-inbox/failed-operations'
    | '/_authenticated/phone/agents'
    | '/_authenticated/phone/analytics'
    | '/_authenticated/phone/calls'
    | '/_authenticated/phone/config'
    | '/_authenticated/phone/routing'
    | '/_authenticated/phone/sms'
    | '/_authenticated/phone/voicemail'
    | '/_authenticated/scheduling/capacity-plans'
    | '/_authenticated/scheduling/custom-slot-requests'
    | '/_authenticated/scheduling/slot-reservations'
    | '/_authenticated/scheduling/slot-templates'
    | '/_authenticated/service-cases/$id'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/settings/profile'
    | '/_authenticated/settings/security'
    | '/_authenticated/admin/'
    | '/_authenticated/companies/'
    | '/_authenticated/customers/'
    | '/_authenticated/invoices/'
    | '/_authenticated/jobs/'
    | '/_authenticated/ops-inbox/'
    | '/_authenticated/phone/'
    | '/_authenticated/settings/'
    | '/_authenticated/admin/system/data-migration'
    | '/_authenticated/admin/system/logs'
    | '/_authenticated/admin/system/migrations'
    | '/_authenticated/admin/system/rbac'
    | '/_authenticated/jobs/$jobId/notes'
    | '/_authenticated/jobs/$jobId/overview'
    | '/_authenticated/service-cases/$id/appointments'
    | '/_authenticated/service-cases/$id/audit'
    | '/_authenticated/service-cases/$id/estimates'
    | '/_authenticated/service-cases/$id/overview'
    | '/_authenticated/service-cases/$id/parts'
    | '/_authenticated/admin/system/'
    | '/_authenticated/jobs/$jobId/'
    | '/_authenticated/service-cases/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/timesheets': {
      id: '/_authenticated/timesheets'
      path: '/timesheets'
      fullPath: '/timesheets'
      preLoaderRoute: typeof AuthenticatedTimesheetsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks': {
      id: '/_authenticated/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthenticatedTasksRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/service-cases': {
      id: '/_authenticated/service-cases'
      path: '/service-cases'
      fullPath: '/service-cases'
      preLoaderRoute: typeof AuthenticatedServiceCasesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/risk-assessments': {
      id: '/_authenticated/risk-assessments'
      path: '/risk-assessments'
      fullPath: '/risk-assessments'
      preLoaderRoute: typeof AuthenticatedRiskAssessmentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/review-tasks': {
      id: '/_authenticated/review-tasks'
      path: '/review-tasks'
      fullPath: '/review-tasks'
      preLoaderRoute: typeof AuthenticatedReviewTasksRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/releases': {
      id: '/_authenticated/releases'
      path: '/releases'
      fullPath: '/releases'
      preLoaderRoute: typeof AuthenticatedReleasesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/phone': {
      id: '/_authenticated/phone'
      path: '/phone'
      fullPath: '/phone'
      preLoaderRoute: typeof AuthenticatedPhoneRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/parts': {
      id: '/_authenticated/parts'
      path: '/parts'
      fullPath: '/parts'
      preLoaderRoute: typeof AuthenticatedPartsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ops-inbox': {
      id: '/_authenticated/ops-inbox'
      path: '/ops-inbox'
      fullPath: '/ops-inbox'
      preLoaderRoute: typeof AuthenticatedOpsInboxRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/office-actions': {
      id: '/_authenticated/office-actions'
      path: '/office-actions'
      fullPath: '/office-actions'
      preLoaderRoute: typeof AuthenticatedOfficeActionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/leads': {
      id: '/_authenticated/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof AuthenticatedLeadsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory': {
      id: '/_authenticated/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof AuthenticatedInventoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/docs': {
      id: '/_authenticated/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof AuthenticatedDocsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dispatch-board': {
      id: '/_authenticated/dispatch-board'
      path: '/dispatch-board'
      fullPath: '/dispatch-board'
      preLoaderRoute: typeof AuthenticatedDispatchBoardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/data-management': {
      id: '/_authenticated/data-management'
      path: '/data-management'
      fullPath: '/data-management'
      preLoaderRoute: typeof AuthenticatedDataManagementRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/booking': {
      id: '/_authenticated/booking'
      path: '/booking'
      fullPath: '/booking'
      preLoaderRoute: typeof AuthenticatedBookingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/phone/': {
      id: '/_authenticated/phone/'
      path: '/'
      fullPath: '/phone/'
      preLoaderRoute: typeof AuthenticatedPhoneIndexRouteImport
      parentRoute: typeof AuthenticatedPhoneRoute
    }
    '/_authenticated/ops-inbox/': {
      id: '/_authenticated/ops-inbox/'
      path: '/'
      fullPath: '/ops-inbox/'
      preLoaderRoute: typeof AuthenticatedOpsInboxIndexRouteImport
      parentRoute: typeof AuthenticatedOpsInboxRoute
    }
    '/_authenticated/jobs/': {
      id: '/_authenticated/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof AuthenticatedJobsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invoices/': {
      id: '/_authenticated/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AuthenticatedInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers/': {
      id: '/_authenticated/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AuthenticatedCustomersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/': {
      id: '/_authenticated/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthenticatedCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/settings/security': {
      id: '/_authenticated/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthenticatedSettingsSecurityRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/profile': {
      id: '/_authenticated/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/service-cases/$id': {
      id: '/_authenticated/service-cases/$id'
      path: '/$id'
      fullPath: '/service-cases/$id'
      preLoaderRoute: typeof AuthenticatedServiceCasesIdRouteImport
      parentRoute: typeof AuthenticatedServiceCasesRoute
    }
    '/_authenticated/scheduling/slot-templates': {
      id: '/_authenticated/scheduling/slot-templates'
      path: '/scheduling/slot-templates'
      fullPath: '/scheduling/slot-templates'
      preLoaderRoute: typeof AuthenticatedSchedulingSlotTemplatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/scheduling/slot-reservations': {
      id: '/_authenticated/scheduling/slot-reservations'
      path: '/scheduling/slot-reservations'
      fullPath: '/scheduling/slot-reservations'
      preLoaderRoute: typeof AuthenticatedSchedulingSlotReservationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/scheduling/custom-slot-requests': {
      id: '/_authenticated/scheduling/custom-slot-requests'
      path: '/scheduling/custom-slot-requests'
      fullPath: '/scheduling/custom-slot-requests'
      preLoaderRoute: typeof AuthenticatedSchedulingCustomSlotRequestsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/scheduling/capacity-plans': {
      id: '/_authenticated/scheduling/capacity-plans'
      path: '/scheduling/capacity-plans'
      fullPath: '/scheduling/capacity-plans'
      preLoaderRoute: typeof AuthenticatedSchedulingCapacityPlansRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/phone/voicemail': {
      id: '/_authenticated/phone/voicemail'
      path: '/voicemail'
      fullPath: '/phone/voicemail'
      preLoaderRoute: typeof AuthenticatedPhoneVoicemailRouteImport
      parentRoute: typeof AuthenticatedPhoneRoute
    }
    '/_authenticated/phone/sms': {
      id: '/_authenticated/phone/sms'
      path: '/sms'
      fullPath: '/phone/sms'
      preLoaderRoute: typeof AuthenticatedPhoneSmsRouteImport
      parentRoute: typeof AuthenticatedPhoneRoute
    }
    '/_authenticated/phone/routing': {
      id: '/_authenticated/phone/routing'
      path: '/routing'
      fullPath: '/phone/routing'
      preLoaderRoute: typeof AuthenticatedPhoneRoutingRouteImport
      parentRoute: typeof AuthenticatedPhoneRoute
    }
    '/_authenticated/phone/config': {
      id: '/_authenticated/phone/config'
      path: '/config'
      fullPath: '/phone/config'
      preLoaderRoute: typeof AuthenticatedPhoneConfigRouteImport
      parentRoute: typeof AuthenticatedPhoneRoute
    }
    '/_authenticated/phone/calls': {
      id: '/_authenticated/phone/calls'
      path: '/calls'
      fullPath: '/phone/calls'
      preLoaderRoute: typeof AuthenticatedPhoneCallsRouteImport
      parentRoute: typeof AuthenticatedPhoneRoute
    }
    '/_authenticated/phone/analytics': {
      id: '/_authenticated/phone/analytics'
      path: '/analytics'
      fullPath: '/phone/analytics'
      preLoaderRoute: typeof AuthenticatedPhoneAnalyticsRouteImport
      parentRoute: typeof AuthenticatedPhoneRoute
    }
    '/_authenticated/phone/agents': {
      id: '/_authenticated/phone/agents'
      path: '/agents'
      fullPath: '/phone/agents'
      preLoaderRoute: typeof AuthenticatedPhoneAgentsRouteImport
      parentRoute: typeof AuthenticatedPhoneRoute
    }
    '/_authenticated/ops-inbox/failed-operations': {
      id: '/_authenticated/ops-inbox/failed-operations'
      path: '/failed-operations'
      fullPath: '/ops-inbox/failed-operations'
      preLoaderRoute: typeof AuthenticatedOpsInboxFailedOperationsRouteImport
      parentRoute: typeof AuthenticatedOpsInboxRoute
    }
    '/_authenticated/ops-inbox/exceptions': {
      id: '/_authenticated/ops-inbox/exceptions'
      path: '/exceptions'
      fullPath: '/ops-inbox/exceptions'
      preLoaderRoute: typeof AuthenticatedOpsInboxExceptionsRouteImport
      parentRoute: typeof AuthenticatedOpsInboxRoute
    }
    '/_authenticated/ops-inbox/custom-slot-approvals': {
      id: '/_authenticated/ops-inbox/custom-slot-approvals'
      path: '/custom-slot-approvals'
      fullPath: '/ops-inbox/custom-slot-approvals'
      preLoaderRoute: typeof AuthenticatedOpsInboxCustomSlotApprovalsRouteImport
      parentRoute: typeof AuthenticatedOpsInboxRoute
    }
    '/_authenticated/ops-inbox/approvals': {
      id: '/_authenticated/ops-inbox/approvals'
      path: '/approvals'
      fullPath: '/ops-inbox/approvals'
      preLoaderRoute: typeof AuthenticatedOpsInboxApprovalsRouteImport
      parentRoute: typeof AuthenticatedOpsInboxRoute
    }
    '/_authenticated/ops-inbox/all': {
      id: '/_authenticated/ops-inbox/all'
      path: '/all'
      fullPath: '/ops-inbox/all'
      preLoaderRoute: typeof AuthenticatedOpsInboxAllRouteImport
      parentRoute: typeof AuthenticatedOpsInboxRoute
    }
    '/_authenticated/ops-inbox/ai-action-reviews': {
      id: '/_authenticated/ops-inbox/ai-action-reviews'
      path: '/ai-action-reviews'
      fullPath: '/ops-inbox/ai-action-reviews'
      preLoaderRoute: typeof AuthenticatedOpsInboxAiActionReviewsRouteImport
      parentRoute: typeof AuthenticatedOpsInboxRoute
    }
    '/_authenticated/jobs/$jobId': {
      id: '/_authenticated/jobs/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/jobs/$jobId'
      preLoaderRoute: typeof AuthenticatedJobsJobIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invoices/new': {
      id: '/_authenticated/invoices/new'
      path: '/invoices/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof AuthenticatedInvoicesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invoices/$invoiceId': {
      id: '/_authenticated/invoices/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/invoices/$invoiceId'
      preLoaderRoute: typeof AuthenticatedInvoicesInvoiceIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers/new': {
      id: '/_authenticated/customers/new'
      path: '/customers/new'
      fullPath: '/customers/new'
      preLoaderRoute: typeof AuthenticatedCustomersNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers/$customerId': {
      id: '/_authenticated/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/$companyId': {
      id: '/_authenticated/companies/$companyId'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/team': {
      id: '/_authenticated/admin/team'
      path: '/team'
      fullPath: '/admin/team'
      preLoaderRoute: typeof AuthenticatedAdminTeamRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/system': {
      id: '/_authenticated/admin/system'
      path: '/system'
      fullPath: '/admin/system'
      preLoaderRoute: typeof AuthenticatedAdminSystemRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/ai-engine': {
      id: '/_authenticated/admin/ai-engine'
      path: '/ai-engine'
      fullPath: '/admin/ai-engine'
      preLoaderRoute: typeof AuthenticatedAdminAiEngineRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/access': {
      id: '/_authenticated/admin/access'
      path: '/access'
      fullPath: '/admin/access'
      preLoaderRoute: typeof AuthenticatedAdminAccessRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/service-cases/$id/': {
      id: '/_authenticated/service-cases/$id/'
      path: '/'
      fullPath: '/service-cases/$id/'
      preLoaderRoute: typeof AuthenticatedServiceCasesIdIndexRouteImport
      parentRoute: typeof AuthenticatedServiceCasesIdRoute
    }
    '/_authenticated/jobs/$jobId/': {
      id: '/_authenticated/jobs/$jobId/'
      path: '/'
      fullPath: '/jobs/$jobId/'
      preLoaderRoute: typeof AuthenticatedJobsJobIdIndexRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRoute
    }
    '/_authenticated/admin/system/': {
      id: '/_authenticated/admin/system/'
      path: '/'
      fullPath: '/admin/system/'
      preLoaderRoute: typeof AuthenticatedAdminSystemIndexRouteImport
      parentRoute: typeof AuthenticatedAdminSystemRoute
    }
    '/_authenticated/service-cases/$id/parts': {
      id: '/_authenticated/service-cases/$id/parts'
      path: '/parts'
      fullPath: '/service-cases/$id/parts'
      preLoaderRoute: typeof AuthenticatedServiceCasesIdPartsRouteImport
      parentRoute: typeof AuthenticatedServiceCasesIdRoute
    }
    '/_authenticated/service-cases/$id/overview': {
      id: '/_authenticated/service-cases/$id/overview'
      path: '/overview'
      fullPath: '/service-cases/$id/overview'
      preLoaderRoute: typeof AuthenticatedServiceCasesIdOverviewRouteImport
      parentRoute: typeof AuthenticatedServiceCasesIdRoute
    }
    '/_authenticated/service-cases/$id/estimates': {
      id: '/_authenticated/service-cases/$id/estimates'
      path: '/estimates'
      fullPath: '/service-cases/$id/estimates'
      preLoaderRoute: typeof AuthenticatedServiceCasesIdEstimatesRouteImport
      parentRoute: typeof AuthenticatedServiceCasesIdRoute
    }
    '/_authenticated/service-cases/$id/audit': {
      id: '/_authenticated/service-cases/$id/audit'
      path: '/audit'
      fullPath: '/service-cases/$id/audit'
      preLoaderRoute: typeof AuthenticatedServiceCasesIdAuditRouteImport
      parentRoute: typeof AuthenticatedServiceCasesIdRoute
    }
    '/_authenticated/service-cases/$id/appointments': {
      id: '/_authenticated/service-cases/$id/appointments'
      path: '/appointments'
      fullPath: '/service-cases/$id/appointments'
      preLoaderRoute: typeof AuthenticatedServiceCasesIdAppointmentsRouteImport
      parentRoute: typeof AuthenticatedServiceCasesIdRoute
    }
    '/_authenticated/jobs/$jobId/overview': {
      id: '/_authenticated/jobs/$jobId/overview'
      path: '/overview'
      fullPath: '/jobs/$jobId/overview'
      preLoaderRoute: typeof AuthenticatedJobsJobIdOverviewRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRoute
    }
    '/_authenticated/jobs/$jobId/notes': {
      id: '/_authenticated/jobs/$jobId/notes'
      path: '/notes'
      fullPath: '/jobs/$jobId/notes'
      preLoaderRoute: typeof AuthenticatedJobsJobIdNotesRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRoute
    }
    '/_authenticated/admin/system/rbac': {
      id: '/_authenticated/admin/system/rbac'
      path: '/rbac'
      fullPath: '/admin/system/rbac'
      preLoaderRoute: typeof AuthenticatedAdminSystemRbacRouteImport
      parentRoute: typeof AuthenticatedAdminSystemRoute
    }
    '/_authenticated/admin/system/migrations': {
      id: '/_authenticated/admin/system/migrations'
      path: '/migrations'
      fullPath: '/admin/system/migrations'
      preLoaderRoute: typeof AuthenticatedAdminSystemMigrationsRouteImport
      parentRoute: typeof AuthenticatedAdminSystemRoute
    }
    '/_authenticated/admin/system/logs': {
      id: '/_authenticated/admin/system/logs'
      path: '/logs'
      fullPath: '/admin/system/logs'
      preLoaderRoute: typeof AuthenticatedAdminSystemLogsRouteImport
      parentRoute: typeof AuthenticatedAdminSystemRoute
    }
    '/_authenticated/admin/system/data-migration': {
      id: '/_authenticated/admin/system/data-migration'
      path: '/data-migration'
      fullPath: '/admin/system/data-migration'
      preLoaderRoute: typeof AuthenticatedAdminSystemDataMigrationRouteImport
      parentRoute: typeof AuthenticatedAdminSystemRoute
    }
  }
}

interface AuthenticatedAdminSystemRouteChildren {
  AuthenticatedAdminSystemDataMigrationRoute: typeof AuthenticatedAdminSystemDataMigrationRoute
  AuthenticatedAdminSystemLogsRoute: typeof AuthenticatedAdminSystemLogsRoute
  AuthenticatedAdminSystemMigrationsRoute: typeof AuthenticatedAdminSystemMigrationsRoute
  AuthenticatedAdminSystemRbacRoute: typeof AuthenticatedAdminSystemRbacRoute
  AuthenticatedAdminSystemIndexRoute: typeof AuthenticatedAdminSystemIndexRoute
}

const AuthenticatedAdminSystemRouteChildren: AuthenticatedAdminSystemRouteChildren =
  {
    AuthenticatedAdminSystemDataMigrationRoute:
      AuthenticatedAdminSystemDataMigrationRoute,
    AuthenticatedAdminSystemLogsRoute: AuthenticatedAdminSystemLogsRoute,
    AuthenticatedAdminSystemMigrationsRoute:
      AuthenticatedAdminSystemMigrationsRoute,
    AuthenticatedAdminSystemRbacRoute: AuthenticatedAdminSystemRbacRoute,
    AuthenticatedAdminSystemIndexRoute: AuthenticatedAdminSystemIndexRoute,
  }

const AuthenticatedAdminSystemRouteWithChildren =
  AuthenticatedAdminSystemRoute._addFileChildren(
    AuthenticatedAdminSystemRouteChildren,
  )

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminAccessRoute: typeof AuthenticatedAdminAccessRoute
  AuthenticatedAdminAiEngineRoute: typeof AuthenticatedAdminAiEngineRoute
  AuthenticatedAdminSystemRoute: typeof AuthenticatedAdminSystemRouteWithChildren
  AuthenticatedAdminTeamRoute: typeof AuthenticatedAdminTeamRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAccessRoute: AuthenticatedAdminAccessRoute,
  AuthenticatedAdminAiEngineRoute: AuthenticatedAdminAiEngineRoute,
  AuthenticatedAdminSystemRoute: AuthenticatedAdminSystemRouteWithChildren,
  AuthenticatedAdminTeamRoute: AuthenticatedAdminTeamRoute,
  AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedOpsInboxRouteChildren {
  AuthenticatedOpsInboxAiActionReviewsRoute: typeof AuthenticatedOpsInboxAiActionReviewsRoute
  AuthenticatedOpsInboxAllRoute: typeof AuthenticatedOpsInboxAllRoute
  AuthenticatedOpsInboxApprovalsRoute: typeof AuthenticatedOpsInboxApprovalsRoute
  AuthenticatedOpsInboxCustomSlotApprovalsRoute: typeof AuthenticatedOpsInboxCustomSlotApprovalsRoute
  AuthenticatedOpsInboxExceptionsRoute: typeof AuthenticatedOpsInboxExceptionsRoute
  AuthenticatedOpsInboxFailedOperationsRoute: typeof AuthenticatedOpsInboxFailedOperationsRoute
  AuthenticatedOpsInboxIndexRoute: typeof AuthenticatedOpsInboxIndexRoute
}

const AuthenticatedOpsInboxRouteChildren: AuthenticatedOpsInboxRouteChildren = {
  AuthenticatedOpsInboxAiActionReviewsRoute:
    AuthenticatedOpsInboxAiActionReviewsRoute,
  AuthenticatedOpsInboxAllRoute: AuthenticatedOpsInboxAllRoute,
  AuthenticatedOpsInboxApprovalsRoute: AuthenticatedOpsInboxApprovalsRoute,
  AuthenticatedOpsInboxCustomSlotApprovalsRoute:
    AuthenticatedOpsInboxCustomSlotApprovalsRoute,
  AuthenticatedOpsInboxExceptionsRoute: AuthenticatedOpsInboxExceptionsRoute,
  AuthenticatedOpsInboxFailedOperationsRoute:
    AuthenticatedOpsInboxFailedOperationsRoute,
  AuthenticatedOpsInboxIndexRoute: AuthenticatedOpsInboxIndexRoute,
}

const AuthenticatedOpsInboxRouteWithChildren =
  AuthenticatedOpsInboxRoute._addFileChildren(
    AuthenticatedOpsInboxRouteChildren,
  )

interface AuthenticatedPhoneRouteChildren {
  AuthenticatedPhoneAgentsRoute: typeof AuthenticatedPhoneAgentsRoute
  AuthenticatedPhoneAnalyticsRoute: typeof AuthenticatedPhoneAnalyticsRoute
  AuthenticatedPhoneCallsRoute: typeof AuthenticatedPhoneCallsRoute
  AuthenticatedPhoneConfigRoute: typeof AuthenticatedPhoneConfigRoute
  AuthenticatedPhoneRoutingRoute: typeof AuthenticatedPhoneRoutingRoute
  AuthenticatedPhoneSmsRoute: typeof AuthenticatedPhoneSmsRoute
  AuthenticatedPhoneVoicemailRoute: typeof AuthenticatedPhoneVoicemailRoute
  AuthenticatedPhoneIndexRoute: typeof AuthenticatedPhoneIndexRoute
}

const AuthenticatedPhoneRouteChildren: AuthenticatedPhoneRouteChildren = {
  AuthenticatedPhoneAgentsRoute: AuthenticatedPhoneAgentsRoute,
  AuthenticatedPhoneAnalyticsRoute: AuthenticatedPhoneAnalyticsRoute,
  AuthenticatedPhoneCallsRoute: AuthenticatedPhoneCallsRoute,
  AuthenticatedPhoneConfigRoute: AuthenticatedPhoneConfigRoute,
  AuthenticatedPhoneRoutingRoute: AuthenticatedPhoneRoutingRoute,
  AuthenticatedPhoneSmsRoute: AuthenticatedPhoneSmsRoute,
  AuthenticatedPhoneVoicemailRoute: AuthenticatedPhoneVoicemailRoute,
  AuthenticatedPhoneIndexRoute: AuthenticatedPhoneIndexRoute,
}

const AuthenticatedPhoneRouteWithChildren =
  AuthenticatedPhoneRoute._addFileChildren(AuthenticatedPhoneRouteChildren)

interface AuthenticatedServiceCasesIdRouteChildren {
  AuthenticatedServiceCasesIdAppointmentsRoute: typeof AuthenticatedServiceCasesIdAppointmentsRoute
  AuthenticatedServiceCasesIdAuditRoute: typeof AuthenticatedServiceCasesIdAuditRoute
  AuthenticatedServiceCasesIdEstimatesRoute: typeof AuthenticatedServiceCasesIdEstimatesRoute
  AuthenticatedServiceCasesIdOverviewRoute: typeof AuthenticatedServiceCasesIdOverviewRoute
  AuthenticatedServiceCasesIdPartsRoute: typeof AuthenticatedServiceCasesIdPartsRoute
  AuthenticatedServiceCasesIdIndexRoute: typeof AuthenticatedServiceCasesIdIndexRoute
}

const AuthenticatedServiceCasesIdRouteChildren: AuthenticatedServiceCasesIdRouteChildren =
  {
    AuthenticatedServiceCasesIdAppointmentsRoute:
      AuthenticatedServiceCasesIdAppointmentsRoute,
    AuthenticatedServiceCasesIdAuditRoute:
      AuthenticatedServiceCasesIdAuditRoute,
    AuthenticatedServiceCasesIdEstimatesRoute:
      AuthenticatedServiceCasesIdEstimatesRoute,
    AuthenticatedServiceCasesIdOverviewRoute:
      AuthenticatedServiceCasesIdOverviewRoute,
    AuthenticatedServiceCasesIdPartsRoute:
      AuthenticatedServiceCasesIdPartsRoute,
    AuthenticatedServiceCasesIdIndexRoute:
      AuthenticatedServiceCasesIdIndexRoute,
  }

const AuthenticatedServiceCasesIdRouteWithChildren =
  AuthenticatedServiceCasesIdRoute._addFileChildren(
    AuthenticatedServiceCasesIdRouteChildren,
  )

interface AuthenticatedServiceCasesRouteChildren {
  AuthenticatedServiceCasesIdRoute: typeof AuthenticatedServiceCasesIdRouteWithChildren
}

const AuthenticatedServiceCasesRouteChildren: AuthenticatedServiceCasesRouteChildren =
  {
    AuthenticatedServiceCasesIdRoute:
      AuthenticatedServiceCasesIdRouteWithChildren,
  }

const AuthenticatedServiceCasesRouteWithChildren =
  AuthenticatedServiceCasesRoute._addFileChildren(
    AuthenticatedServiceCasesRouteChildren,
  )

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsAppearanceRoute: typeof AuthenticatedSettingsAppearanceRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsProfileRoute: typeof AuthenticatedSettingsProfileRoute
  AuthenticatedSettingsSecurityRoute: typeof AuthenticatedSettingsSecurityRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsAppearanceRoute: AuthenticatedSettingsAppearanceRoute,
  AuthenticatedSettingsNotificationsRoute:
    AuthenticatedSettingsNotificationsRoute,
  AuthenticatedSettingsProfileRoute: AuthenticatedSettingsProfileRoute,
  AuthenticatedSettingsSecurityRoute: AuthenticatedSettingsSecurityRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedJobsJobIdRouteChildren {
  AuthenticatedJobsJobIdNotesRoute: typeof AuthenticatedJobsJobIdNotesRoute
  AuthenticatedJobsJobIdOverviewRoute: typeof AuthenticatedJobsJobIdOverviewRoute
  AuthenticatedJobsJobIdIndexRoute: typeof AuthenticatedJobsJobIdIndexRoute
}

const AuthenticatedJobsJobIdRouteChildren: AuthenticatedJobsJobIdRouteChildren =
  {
    AuthenticatedJobsJobIdNotesRoute: AuthenticatedJobsJobIdNotesRoute,
    AuthenticatedJobsJobIdOverviewRoute: AuthenticatedJobsJobIdOverviewRoute,
    AuthenticatedJobsJobIdIndexRoute: AuthenticatedJobsJobIdIndexRoute,
  }

const AuthenticatedJobsJobIdRouteWithChildren =
  AuthenticatedJobsJobIdRoute._addFileChildren(
    AuthenticatedJobsJobIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedBookingRoute: typeof AuthenticatedBookingRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedDataManagementRoute: typeof AuthenticatedDataManagementRoute
  AuthenticatedDispatchBoardRoute: typeof AuthenticatedDispatchBoardRoute
  AuthenticatedDocsRoute: typeof AuthenticatedDocsRoute
  AuthenticatedInventoryRoute: typeof AuthenticatedInventoryRoute
  AuthenticatedLeadsRoute: typeof AuthenticatedLeadsRoute
  AuthenticatedOfficeActionsRoute: typeof AuthenticatedOfficeActionsRoute
  AuthenticatedOpsInboxRoute: typeof AuthenticatedOpsInboxRouteWithChildren
  AuthenticatedPartsRoute: typeof AuthenticatedPartsRoute
  AuthenticatedPhoneRoute: typeof AuthenticatedPhoneRouteWithChildren
  AuthenticatedReleasesRoute: typeof AuthenticatedReleasesRoute
  AuthenticatedReviewTasksRoute: typeof AuthenticatedReviewTasksRoute
  AuthenticatedRiskAssessmentsRoute: typeof AuthenticatedRiskAssessmentsRoute
  AuthenticatedServiceCasesRoute: typeof AuthenticatedServiceCasesRouteWithChildren
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedTasksRoute: typeof AuthenticatedTasksRoute
  AuthenticatedTimesheetsRoute: typeof AuthenticatedTimesheetsRoute
  AuthenticatedCompaniesCompanyIdRoute: typeof AuthenticatedCompaniesCompanyIdRoute
  AuthenticatedCustomersCustomerIdRoute: typeof AuthenticatedCustomersCustomerIdRoute
  AuthenticatedCustomersNewRoute: typeof AuthenticatedCustomersNewRoute
  AuthenticatedInvoicesInvoiceIdRoute: typeof AuthenticatedInvoicesInvoiceIdRoute
  AuthenticatedInvoicesNewRoute: typeof AuthenticatedInvoicesNewRoute
  AuthenticatedJobsJobIdRoute: typeof AuthenticatedJobsJobIdRouteWithChildren
  AuthenticatedSchedulingCapacityPlansRoute: typeof AuthenticatedSchedulingCapacityPlansRoute
  AuthenticatedSchedulingCustomSlotRequestsRoute: typeof AuthenticatedSchedulingCustomSlotRequestsRoute
  AuthenticatedSchedulingSlotReservationsRoute: typeof AuthenticatedSchedulingSlotReservationsRoute
  AuthenticatedSchedulingSlotTemplatesRoute: typeof AuthenticatedSchedulingSlotTemplatesRoute
  AuthenticatedCompaniesIndexRoute: typeof AuthenticatedCompaniesIndexRoute
  AuthenticatedCustomersIndexRoute: typeof AuthenticatedCustomersIndexRoute
  AuthenticatedInvoicesIndexRoute: typeof AuthenticatedInvoicesIndexRoute
  AuthenticatedJobsIndexRoute: typeof AuthenticatedJobsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedBookingRoute: AuthenticatedBookingRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedDataManagementRoute: AuthenticatedDataManagementRoute,
  AuthenticatedDispatchBoardRoute: AuthenticatedDispatchBoardRoute,
  AuthenticatedDocsRoute: AuthenticatedDocsRoute,
  AuthenticatedInventoryRoute: AuthenticatedInventoryRoute,
  AuthenticatedLeadsRoute: AuthenticatedLeadsRoute,
  AuthenticatedOfficeActionsRoute: AuthenticatedOfficeActionsRoute,
  AuthenticatedOpsInboxRoute: AuthenticatedOpsInboxRouteWithChildren,
  AuthenticatedPartsRoute: AuthenticatedPartsRoute,
  AuthenticatedPhoneRoute: AuthenticatedPhoneRouteWithChildren,
  AuthenticatedReleasesRoute: AuthenticatedReleasesRoute,
  AuthenticatedReviewTasksRoute: AuthenticatedReviewTasksRoute,
  AuthenticatedRiskAssessmentsRoute: AuthenticatedRiskAssessmentsRoute,
  AuthenticatedServiceCasesRoute: AuthenticatedServiceCasesRouteWithChildren,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedTasksRoute: AuthenticatedTasksRoute,
  AuthenticatedTimesheetsRoute: AuthenticatedTimesheetsRoute,
  AuthenticatedCompaniesCompanyIdRoute: AuthenticatedCompaniesCompanyIdRoute,
  AuthenticatedCustomersCustomerIdRoute: AuthenticatedCustomersCustomerIdRoute,
  AuthenticatedCustomersNewRoute: AuthenticatedCustomersNewRoute,
  AuthenticatedInvoicesInvoiceIdRoute: AuthenticatedInvoicesInvoiceIdRoute,
  AuthenticatedInvoicesNewRoute: AuthenticatedInvoicesNewRoute,
  AuthenticatedJobsJobIdRoute: AuthenticatedJobsJobIdRouteWithChildren,
  AuthenticatedSchedulingCapacityPlansRoute:
    AuthenticatedSchedulingCapacityPlansRoute,
  AuthenticatedSchedulingCustomSlotRequestsRoute:
    AuthenticatedSchedulingCustomSlotRequestsRoute,
  AuthenticatedSchedulingSlotReservationsRoute:
    AuthenticatedSchedulingSlotReservationsRoute,
  AuthenticatedSchedulingSlotTemplatesRoute:
    AuthenticatedSchedulingSlotTemplatesRoute,
  AuthenticatedCompaniesIndexRoute: AuthenticatedCompaniesIndexRoute,
  AuthenticatedCustomersIndexRoute: AuthenticatedCustomersIndexRoute,
  AuthenticatedInvoicesIndexRoute: AuthenticatedInvoicesIndexRoute,
  AuthenticatedJobsIndexRoute: AuthenticatedJobsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
